module.exports = __webpack_public_path__ + "static/media/orange-loader.566da8af.svg";